import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import Loader from '../../../../Loader/Loader';
import { crusaders } from '../../../../ClientUpdater/ClientUpdater'
import CreateCompanyModal from '../CreateCompanyModal/CreateCompanyModal';
import { AtomHeaderDataState } from '../../../../RecoilState/AtomHeaderDataState';
import { useRecoilValue } from 'recoil';
import EditCompanyModal from '../EditCompanyModal/EditCompanyModal';
import './CompanyModal.css';


const CompanyModal = ({ isOpen, onClose }) => {
  
  const [viewCompany, setViewCompany]= useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchColumn, setSearchColumn] = useState(""); 
  const [searchKeyword, setSearchKeyword] = useState(""); 
  const [message, setMessage] = useState("");
  const [isCreateCompanyModalOpen, setCreateCompanyModalOpen] = useState(false);
  const roleValue = useRecoilValue(AtomHeaderDataState)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [isEditCompanyModalOpen, setIsEditCompanyModalOpen] = useState(false) 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const usersPerPage = rowsPerPage;
  const [pageNumber, setPageNumber] = useState(0);

  const usersTable = async () => {
    try {
      const response = await axios.get(`https://worxit.co.za/api/viewCompany.php`);
      const newData = response.data.records;
      setViewCompany(newData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data: ", error);
    }
  };
  
useEffect(() => {
  usersTable(); // Initial call
  const intervalId = setInterval(usersTable, 3000);
  return () => clearInterval(intervalId);
}, [setViewCompany]); // Empty dependency array to run this effect only once
  
  
  const filteredSearch = viewCompany.filter((user) => {
    if (searchColumn !== "") {
      return user[searchColumn].toLowerCase().includes(searchKeyword.toLowerCase());
    }
    // If "All" is selected, check if any column contains the search keyword
    return Object.values(user).some((value) =>
      value.toLowerCase().includes(searchKeyword.toLowerCase())
    );
  });
    
  useEffect(() => {
    if (filteredSearch.length === 0 && searchKeyword !== "") {
      setMessage("No Match Found");
    } else {
      setMessage("");
    }
  }, [filteredSearch, searchColumn, searchKeyword]);


  const editForm = (company) => {
    setSelectedCompany(company);
    setIsEditCompanyModalOpen(true);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="company-modal">
      <div className="company-modal-content">
        <h3 className='company-title'>Company</h3>
        <div className="row filter">
          <div className="column1AllUsers">
            <label className='searchByTitle'>Search By:</label>
          </div>
          <div className="column2AllUsers">
            <select
              className="searchInput"
              value={searchColumn}
              onChange={(e) => setSearchColumn(e.target.value)}
            >
              <option value="">All</option>
              <option value="coNo">Company No</option>
              <option value="coName">Company Name</option>
              <option value="coReg">Company Reg</option>
              <option value="coContact">Company Contact</option>
              <option value="coAdd">Company Address</option>
            </select>
          </div>
        
          <div className="column3AllUsers">
            <input
              type="text"
              className="searchInput"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
          </div>
        </div>
        {roleValue[0]?.role === 0 ? (
            <div className='createCompanyBtnCont'>
              <button className='createCompanybtn' onClick={() => setCreateCompanyModalOpen(true)}>Create</button>
            </div>
            ) : null
          }
        
        {/* <h7>Latest 5 Orders Completed...</h7> */}
        <table className="usersTbl">
            <thead>
                <tr>
                    <th>Company No</th>
                    <th>Company Name</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
              {isLoading ? (
                  <Loader />
                ) : filteredSearch.length > 0 ? (
                  // .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
                  filteredSearch
                    .slice(pageNumber * usersPerPage, (pageNumber + 1) * usersPerPage)
                    .map((viewCompany, index) => (
                      <tr onClick={() => editForm(viewCompany)} key={index}>
                        <td>{viewCompany.coNo}</td>
                        <td>{viewCompany.coName}</td>
                        <td>
                          <div
                            className={`statusCircle ${
                              viewCompany.status === '1' ? 'green' : 'red'
                            }`}
                          ></div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="6">No Records Found</td>
                  </tr>
                )}

                </tbody>
            </table>   
            <div className="rows-per-page">
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                pageCount={Math.ceil(filteredSearch.length / usersPerPage)}
                onPageChange={({ selected }) => setPageNumber(selected)}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
              />
              </div>
            {message && <p className="NoMatchFoundMsg">{message}</p>} 
        <div onClick={onClose} className='closeContUserModal' >
          <span className='closeUserModalIcon'>
            <FaTimes />
          </span>
        </div>
        {isCreateCompanyModalOpen && (
          <CreateCompanyModal 
            isOpen={isCreateCompanyModalOpen} 
            onClose={() => setCreateCompanyModalOpen(false)} />
        )}
        {selectedCompany && (
          <EditCompanyModal
            isOpen={isEditCompanyModalOpen}
            onClose={() => setIsEditCompanyModalOpen(false)}
            company={selectedCompany}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyModal;
